/** Angular */
import { InjectionToken } from '@angular/core';
/** Enums */
import { BydFeatureFlagsEnum } from '../enums';
/**
 * The beyond feature flags injection token
 *
 * @example
 *   {
 *      provide: BYD_FEATURE_FLAG_INJECTION_TOKEN,
 *      useValue: "featureFlags" // The feature flags key in the run time environment file,
 *                               // "featureFlags": {
 *                               //     "table_dynamic": true,
 *                               //     "table_static": true
 *                               //  }
 *   }
 */
export const BYD_FEATURE_FLAGS_INJECTION_TOKEN = new InjectionToken<string>(
  'The beyond environment configuration injection token',
  { factory: () => BydFeatureFlagsEnum.KEY }
);
